(function($) {
    $('.hotspot-component-section').each(function() {
        const $section = $(this);
        const $hotspotContainer = $section.find('.hcs-wrap .inner-wrap');

        const isMobile = () => $(window).width() < 768;

        /* Close button */
        $section.on('click', '.close_ihp', function() {
            resetHotspot();
        });

        /* Click hotspot */
        $section.on(
            'click',
            '.drag_element .point_style, .drag_element .ihotspot_hastooltop',
            function(e) {
                e.stopPropagation();
                const $dragElement = $(this).closest('.drag_element');
                const isActive = $dragElement.hasClass('active');

                $section
                    .find('.drag_element')
                    .not($dragElement)
                    .removeClass('active');

                if (!isActive) {
                    $dragElement.addClass('active');

                    if (isMobile()) {
                        const tooltipHtml = $dragElement
                            .find('.box_view_html')
                            .html();

                        $section.addClass('show');
                        $hotspotContainer.html(tooltipHtml).addClass('active');
                    } else {
                        $hotspotContainer.empty().removeClass('active');
                    }
                } else {
                    resetHotspot();
                }
            },
        );

        /* Tooltip initialization */
        $section.find('.drag_element').each(function() {
            const $dragElement = $(this);

            const tooltipHtml = $dragElement
                .find('.ihotspot_tooltop_html')
                .data('html');

            if (!tooltipHtml || tooltipHtml.trim() === '') {
                return;
            }

            if (!$dragElement.find('.tooltip-wrap').length) {
                $dragElement.append('<div class="tooltip-wrap"></div>');
            }

            $dragElement.find('.tooltip-wrap').html(tooltipHtml);
        });

        function resetHotspot() {
            $section.removeClass('show');
            $section.find('.drag_element').removeClass('active');
            $hotspotContainer.empty().removeClass('active');
        }
    });

    /* Global outside click */
    $(document).on('click', function(e) {
        $('.hotspot-component-section').each(function() {
            const $section = $(this);

            if (
                !$(e.target).closest(
                    $section.find('.hcs-wrap .inner-wrap, .drag_element'),
                ).length
            ) {
                $section.removeClass('show');
                $section.find('.drag_element').removeClass('active');
                $section
                    .find('.hcs-wrap .inner-wrap')
                    .empty()
                    .removeClass('active');
            }
        });
    });
})(jQuery);
